import { Flex } from 'foundations-components/components/Flex';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import ReportActionsDropdownButton from './ReportActionsDropdownButton';
import { List } from 'foundations-components/transitional/components/List';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomToolbar({
  additionalReportActions,
  isReportActionsDisabled
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  if (!additionalReportActions || additionalReportActions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "end",
    alignItems: "start",
    "data-open": isDropdownOpen,
    "data-test-id": "report-card-actions",
    children: /*#__PURE__*/_jsx(Dropdown, {
      Button: ReportActionsDropdownButton,
      placement: "bottom left",
      buttonUse: "link",
      disabled: isReportActionsDisabled,
      onOpenChange: () => setIsDropdownOpen(!isDropdownOpen),
      buttonStyles: {
        padding: '0'
      },
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: additionalReportActions
      })
    })
  });
}